import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import {TranslateModule, TranslateStaticLoader, TranslateLoader} from 'ng2-translate/ng2-translate';
import {Http} from '@angular/http';
import { GlobalVars } from '../providers/global-vars';
import { ApiCaller } from '../providers/api-caller';
import { Storage } from '@ionic/storage';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup



import { HomePage } from '../pages/home/home';
import { AccessCodesPage } from '../pages/access-codes/access-codes';
import { PartnersPage } from '../pages/partners/partners';
import { MyGatesPage } from '../pages/my-gates/my-gates';
import { TechniciansPage } from '../pages/technicians/technicians';
import { GateGuestsPage } from '../pages/gate-guests/gate-guests';
import { NewGuestPage } from '../pages/new-guest/new-guest';


export function createTranslateLoader(http: Http) {
  return new TranslateStaticLoader(http, './assets/i18n', '.json');
}

@NgModule({
  declarations: [
    MyApp,
    HomePage,
      AccessCodesPage,
      PartnersPage,
      TechniciansPage,
      GateGuestsPage,
      MyGatesPage,
      NewGuestPage
  ],
  imports: [
      NgIdleKeepaliveModule.forRoot(),
    IonicModule.forRoot(MyApp, {}, {
         links: [
            { component: AccessCodesPage, name: ' AccessCodes', segment: 'ac/:deepAccessCode' },
  //          { component: PartnersPage, name: ' AccessCodes', segment: 'ac/:deepAccessCode' },
            { component: PartnersPage, name: ' Partners', segment: 'partners' },
             { component: MyGatesPage, name: ' MyGates', segment: 'gg/:mg' }
        ]
      }),
      TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [Http]
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
      AccessCodesPage,
      PartnersPage,
      TechniciansPage,
      GateGuestsPage,
      MyGatesPage,
      NewGuestPage
  ],
  providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, GlobalVars, ApiCaller, Storage]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts